import {IJobSettings} from "./JobSettings";

export interface IJobDefinitionStep {
	id: number;
	description: string;
	concurrency: number;
	order: number;
	inputStep?: IJobDefinitionStep;
	jobSettings?: IJobSettings;
	customSettings?: string;
	processor: Processor;
	startMode: StartMode;
}

export enum Processor {
	SoftRulesCustomerWithPolicies = "SOFT_RULES_CUSTOMER_WITH_POLICIES",
	SoftRules = "SOFT_RULES",
	SoftRulesAnvaXmlCompare = "SOFT_RULES_ANVA_XML_COMPARE",
	CsvCreator = "CSV_CREATOR",
	SnsPublish = "SNS_PUBLISH",
	CsvComparer = "CSV_COMPARER",
	LambdaFunction = "LAMBDA_FUNCTION",
	PythonScript = "PYTHON_SCRIPT",
	ExcelCreator = "EXCEL_CREATOR",
	
}

export enum StartMode {
	Manual = "MANUAL",
	Automatic = "AUTOMATIC",
	AutomaticIfPreviousStepSucceeded = "AUTOMATIC_IF_PREVIOUS_STEP_SUCCEEDED",
	AutomaticOnlySucceededRecords = "AUTOMATIC_ONLY_SUCCEEDED_RECORDS",
}
